import { format } from 'date-fns';

const SHORT_DATE_FORMAT = 'yyyy-MM-dd';
export const toShortDate = (date: Date) => format(date, SHORT_DATE_FORMAT);

export const toMonthAbvDate = (date: Date) => format(date, 'MMM d, yyyy');

export const toDetailedDate = (date: Date) => format(date, 'MMMM dd, yyyy hh:mm a');

export const toDetailedMonthAbvDate = (date: Date) => format(date, 'MMM dd, yyyy, hh:mm a');
export const DATE_PLACEHOLDER = 'YYYY/MM/DD';

/**
 * Return a number as a two digit string, with a leading zero if needed
 * @param num 
 * @returns 
 */
const pad = (num: number) => `${Math.floor(Math.abs(num))}`.padStart(2, '0');


/**
 * Get the formatted date in utc
 * adding one to the month because getUTCMonth returns 0 for January
 * returns a date string in the format of YYYY-MM-DD, ex: 2023-01-04
 * @param date 
 * @returns 
 */
export const toUTCShortDate = (date: Date): string => {
    return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() +1)}-${pad(date.getUTCDate())}`;
};
